import { render } from "./People.vue?vue&type=template&id=d6cf7b9a&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"

import "./People.vue?vue&type=style&index=0&id=d6cf7b9a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cf7b9a"]])

export default __exports__